import React from 'react';
import {
  RiskButton,
  RiskButtonRemove,
  SelectFirstNotice,
} from './v2/ResultSlotCard.styles';

function ButtonComponentLogicBackoffice({
  type,
  processingQuote,
  removeItemFromCart,
  requestInfo,
  riskQuotations,
}) {
  return (
    <div className="d-flex justify-content-end ms-auto gap-2">
      {type.id === 'res_civile' && processingQuote !== null && (
        <RiskButtonRemove
          className="btn btn-danger"
          onClick={() => removeItemFromCart(processingQuote.id)}
        >
          Rimuovi
        </RiskButtonRemove>
      )}

      {riskQuotations
        && riskQuotations[type.id] !== undefined
        && riskQuotations[type.id].map((quote, idx) => {
          // Adriatic/Euroherc's own assistenza_stradale can't always be
          // trusted for these merit classes, so let the broker swap company
          // instead of only being able to remove it outright.
          const canChangeCompany = requestInfo.product_id == 1
            && type.id === 'assistenza_stradale'
            && (processingQuote.company_id === 1 || processingQuote.company_id === 17)
            && ['N', 'S', 'A'].includes(requestInfo?.vehicle?.inherit_merit_class);

          return (
            <React.Fragment key={idx}>
              {type.id === quote.quote_type && (
                canChangeCompany ? (
                  <RiskButton
                    className="btn btn-success"
                    data-bs-toggle="modal"
                    data-bs-target={`#${type.id}`}
                  >
                    Cambia
                  </RiskButton>
                ) : (
                  <RiskButtonRemove
                    className="btn btn-danger"
                    onClick={() => removeItemFromCart(quote.id)}
                  >
                    Rimuovi
                  </RiskButtonRemove>
                )
              )}
            </React.Fragment>
          );
        })}

      {riskQuotations
        && riskQuotations[type.id] === undefined
        && processingQuote !== null
        && type.id !== 'res_civile' && (
          <RiskButton
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target={`#${type.id}`}
          >
            Aggiungi
          </RiskButton>
      )}

      {requestInfo.processing_quotation_id === null
        && type.id !== 'res_civile' && (
          <SelectFirstNotice>
            Seleziona Prima La Responsibilita Civile
          </SelectFirstNotice>
      )}
      {type.id === 'res_civile' && (
        <RiskButton
          className="btn btn-success"
          data-bs-toggle="modal"
          data-bs-target={`#${type.id}`}
        >
          Aggiungi
        </RiskButton>
      )}
    </div>
  );
}

export default ButtonComponentLogicBackoffice;
